import axios from "axios/index";

export default axios.create({
    baseURL: "https://api.zizy.io/v1/",
    responseType: "json",
});

